import { IFilter, IRootState} from '@/store/types/IRootState';

const filterGetters = {
    getCheckedFilters(state: IRootState, getters: any): IFilter[] {
        return getters.getCheckedAttributeFilters
            .concat(getters.getCheckedManufacturerFilters)
            .concat(getters.getCheckedCompanyFilters)
            .concat(getters.getCheckedItemTypeFilters)
            .concat(getters.getCheckedCategoryFilters)
            ;
    },
    hasAnyFilter(state: IRootState, getters: any): boolean {
        return getters.hasManufacturerFilters
            || getters.hasAttributeFilters
            || getters.hasCompanyFilters
            || getters.hasItemTypeFilters
            || getters.hasCategoryFilters
            ;
    },
};

export default filterGetters;
